export default () => ({
  identityType: [
    'Adhaar ID',
    'Voter ID',
    'Driving License',
    'Pan Card',
    'Samagra Id'
  ],
  // financialYear: [
  //   '2017-2018',
  //   '2018-2019',
  //   '2019-2020',
  //   '2020-2021',
  //   '2021-2022'
  // ],
  casteType: [
    '2017-2018',
    '2018-2019',
    '2019-2020',
    '2020-2021',
    '2021-2022'
  ],
  // casteType: [
  //   'General',
  //   'Other Backward Class/OBC',
  //   'Schedule Caste/SC',
  //   'Schedule Tribe/ST',
  //   'NOT TO DISCLOSE'
  // ],
  relationshipType: [
    'SON/OF',
    'DAUGHTER/0F',
    'WIFE/0F',
    'HUSBAND/0F',
    'CARE/OF'
  ],
  productUnit : [
    {
      text: "Bags",
      value: "Bags"
    },
    {
      text: "Bale",
      value: "Bale"
    },
    {
      text: "Buckets",
      value: "Buckets"
    },
    {
      text: "Buckles",
      value: "BuckleS"
    },
    {
      text: "Bundles",
      value: "Bundles"
    },
    {
      text: "BOU",
      value: "Billion of Units"
    },
    {
      text: "Box",
      value: "Box"
    },
    {
      text: "Can",
      value: "Can"
    },
    {
      text: "CBM",
      value: "Cubic Meter"
    },
    {
      text: "CCM",
      value: "Cubic Centimeter"
    },
    {
      text: "CMS",
      value: "Centimeter"
    },
    {
      text: "CTN",
      value: "Cartoons"
    },
    {
      text: "DOZ",
      value: "Dozens"
    },
    {
      text: "DRM",
      value: "Drums"
    },  
    {
      text: "DZN",
      value: "Dozens"
    },
    {
      text: "FTS",
      value: "Feet"
    },
    {
      text: "GAL",
      value: "Gallon"
    },
    {
      text: "GGK",
      value: "Great Gross"
    },
    {
      text: "GMS",
      value: "Gram"
    },
    {
      text: "GRS",
      value: "Gross"
    },
    {
      text: "GYD",
      value: "Gross Yards"
    },
    {
      text: "JAR",
      value: "Jar"
    },
    {
      text: "KGS",
      value: "Kilogram"
    },
    {
      text: "KLR",
      value: "Kiloliter"
    },
    {
      text: "KME",
      value: "Kilometer"
    },
    {
      text: "LTR",
      value: "Liter"
    },
    {
      text: "MLT",
      value: "Mililiter"
    },
    {
      text: "MTR",
      value: "Meter"
    },
    {
      text: "MTS",
      value: "Metric Tons"
    },
    {
      text: "NOS",
      value: "Numbers"
    },
    {
      text: "PAC",
      value: "Packs"
    },
    {
      text: "Pieces",
      value: "Pieces"
    },
    {
      text: "PRS",
      value: "Pairs"
    },
    
    {
      text: "QTL",
      value: "Quintal"
    },
    
    {
      text: "ROL",
      value: "Rolls"
    },
    {
      text: "SET",
      value: "Sets"
    },
    {
      text: "SQF",
      value: "SquareFeet"
    },
    {
      text: "SQM",
      value: "SquareMeter"
    },
    {
      text: "SQY",
      value: "SquareYards"
    },
    {
      text: "Stripe",
      value: "Stripe"
    },
    {
      text: "TBS",
      value: "Tablets"
    },
    {
      text: "TGM",
      value: "TenGross"
    },
    {
      text: "THD",
      value: "Thousands"
    },
    {
      text: "TIN",
      value: "Tin"
    },
    {
      text: "TON",
      value: "Tonnes"
    },
    {
      text: "TUB",
      value: "Tubes"
    },
    {
      text: "UGS",
      value: "US Gallons"
    },
    {
      text: "UNT",
      value: "Units"
    },
    {
      text: "YDS",
      value: "Yards"
    },
    {
      text: "OTH",
      value: "Others"
    },
  ],
    
  village: [
    'Amoda',
    'Attaisa',
    'Bamhori',
    'BarhyaBada',
    'banwari',
    'Baskheda',
    'Bhainsa',
    'Bhatera',
    'Chadon',
    'Dhana',
    'Jiriya',
    'Kamti',
    'khakariya',
    'Khakariyakheda/guzar-kheda',
    'Kheri',
    'Paloha',
    'Panagar',
    'Sadumar',
    'Sasbahu',
    'Supari',
    'Tekapar',
    'Thareri',
    'Udni Pipariya',
    'Utni',    
  ],
  block: [
    'Saikheda',
    'Chirahkala',
    'Banwari',
    'Salichouka',
    'Chichli',
    'Bohani',
    'Kodiya',
    'Sehora',
  ],
  tehsil: [
    'Babai',
    'Bankhedi',
    'Bareli',
    'Begumganj',
    'Gadarwara',
    'Gairatganj',
    'Goharganj',
    'Gotegao',
    'Hoshangabad',
    'Itarsi',
    'Kareli',
    'Narsinghpur',
    'Pipariya',
    'Raisen',
    'Tendukheda',
    'Seoni-Malwa',
    'Silwani',
    'Sohagpur',
    'Udaipura'
  ],
  district: [
    'Agar Malwa',
    'Alirajpur',
    'Anuppur',
    'Ashoknagar',
    'Balaghat',
    'Barwani',
    'Betul',
    'Bhind',
    'Bhopal',
    'Chatarpur',
    'Chindwara',
    'Damoh',
    'Datia',
    'Dewas',
    'Dhar',
    'Dindori',
    'East Nimar',
    'Guna',
    'Gwalior',
    'Harda',
    'Hoshangabad',
    'Indore',
    'Jabalpur',
    'Jhabua',
    'Katni',
    'Khandwa',
    'Khargone',
    'Mandla',
    'Mandsaur',
    'Murena',
    'Narsinghpur',
    'Neemach',
    'Panna',
    'Raisen',
    'Rajgarh',
    'Ratlam',
    'Reewa',
    'Sagar',
    'Satna',
    'Sehore',
    'Seoni',
    'Shahdol',
    'Shajapur',
    'Sheopur',
    'Shivpuri',
    'Sidhi',
    'Singhrauli',
    'Tikamgarh',
    'Ujjain',
    'Umaria',
    'Vidisha',
    'West Nimar'
  ],
  state: [
    {
        "code": "01",
        "state": "Jammu & Kashmir"
    },
    {
        "code": "19",
        "state": "West Bengal"
    },
    {
        "code": "02",
        "state": "Himachal Pradesh"
    },
    {
        "code": "20",
        "state": "Jharkhand"
    },
    {
        "code": "03",
        "state": "Punjab"
    },
    {
        "code": "21",
        "state": "Orissa"
    },
    {
        "code": "04",
        "state": "Chandigarh"
    },
    {
        "code": "22",
        "state": "Chhattisgarh"
    },
    {
        "code": "05",
        "state": "Uttarakhand"
    },
    {
        "code": "23",
        "state": "Madhya Pradesh"
    },
    {
        "code": "06",
        "state": "Haryana"
    },
    {
        "code": "24",
        "state": "Gujarat"
    },
    {
        "code": "07",
        "state": "Delhi"
    },
    {
        "code": "25",
        "state": "Daman & Diu"
    },
    {
        "code": "08",
        "state": "Rajasthan"
    },
    {
        "code": "26",
        "state": "Dadra & Nagar Haveli"
    },
    {
        "code": "09",
        "state": "Uttar Pradesh"
    },
    {
        "code": "27",
        "state": "Maharashtra"
    },
    {
        "code": "10",
        "state": "Bihar"
    },
    {
        "code": "28",
        "state": "Andhra Pradesh"
    },
    {
        "code": "11",
        "state": "Sikkim"
    },
    {
        "code": "29",
        "state": "Karnataka"
    },
    {
        "code": "12",
        "state": "Arunachal Pradesh"
    },
    {
        "code": "30",
        "state": "Goa"
    },
    {
        "code": "13",
        "state": "Nagaland"
    },
    {
        "code": "31",
        "state": "Lakshadweep"
    },
    {
        "code": "14",
        "state": "Manipur"
    },
    {
        "code": "32",
        "state": "Kerala"
    },
    {
        "code": "15",
        "state": "Mizoram"
    },
    {
        "code": "33",
        "state": "Tamil Nadu"
    },
    {
        "code": "16",
        "state": "Tripura"
    },
    {
        "code": "34",
        "state": "Puducherry"
    },
    {
        "code": "17",
        "state": "Meghalaya"
    },
    {
        "code": "35",
        "state": "Andaman & Nicobar Islands"
    },
    {
        "code": "18",
        "state": "Assam"
    },
    {
        "code": "36",
        "state": "Telangana "
    },
    {
        "code": "37",
        "state": "Andhra Pradesh(New) "
    }
  ],
  GST_Type : [
    'Regular',
    'Composite',
    // 'Consumer',
    // 'Unregistered'
  ],
  firmType: [
    'Normal',  
    'Government Entity',
    'SEZ',
    'Deemed'
  ],
  purchaseType: [
    'Goods',
    'Services'
  ],
  country: [
    "Afghanistan", 
    "Albania", 
    "Algeria", 
    "Andorra", 
    "Angola", 
    "Anguilla",
    "Antigua &amp; Barbuda", 
    "Argentina", "Armenia", 
    "Aruba", 
    "Australia", 
    "Austria", 
    "Azerbaijan", 
    "Bahamas",
    "Bahrain", 
    "Bangladesh", 
    "Barbados", 
    "Belarus", 
    "Belgium", 
    "Belize", 
    "Benin", 
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia &amp; Herzegovina",
    "Botswana",
    "Brazil",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Cape Verde", 
    "Cayman Islands",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote D Ivoire",
    "Croatia",
    "Cruise Ship",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Polynesia",
    "French West Indies",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kuwait",
    "Kyrgyz Republic",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Pierre &amp; Miquelon",
    "Samoa",
    "San Marino",
    "Satellite",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Africa",
    "South Korea",
    "Spain",
    "Sri Lanka",
    "St Kitts &amp; Nevis",
    "St Lucia",
    "St Vincent",
    "St. Lucia",
    "Sudan",
    "Suriname", "Swaziland",
    "Sweden", 
    "Switzerland", 
    "Syria", 
    "Taiwan", 
    "Tajikistan", 
    "Tanzania", 
    "Thailand", 
    "Timor L'Este", 
    "Togo", 
    "Tonga", 
    "Trinidad &amp; Tobago", 
    "Tunisia", 
    "Turkey", 
    "Turkmenistan", 
    "Turks &amp; Caicos", 
    "Uganda", 
    "Ukraine", 
    "United Arab Emirates", 
    "United Kingdom", 
    "Uruguay", 
    "Uzbekistan", 
    "Venezuela", 
    "Vietnam", 
    "Virgin Islands (US)", 
    "Yemen", 
    "Zambia", 
    "Zimbabwe"
  ],
  gender: [
    'Male',
    'Female',
    'Not to disclose'
  ],
  marital: [
    'Single',
    'Married',
    'Widow',
    'Not to disclose'
  ],
  brands: null,
  selectedBrand: null,
  finYear:null,
  adminEmail : null,
  roleAndPermission : null,
  brandFinYear : null,
  stockReportTypes:[
    {
      text: "Last Purchasing Price",
      value: "LPP"
    },
    {
      text: "Last Sale Price",
      value: "LSP"
    },
    {
      text: "Average Purchasing Price",
      value: "APP"
    },
    {
      text: "Average Sale Price",
      value: "ASP"
    },
    {
      text: "First In First Out",
      value: "FIFO"
    },
    {
      text: "Last In First Out",
      value: "LIFO"
    }
  ],
  brandPackageTypes:[
    'BASIC',
    'ADVANCED',
    'PREMIUM',
    'EXCLUSIVE',
  ],
})



// WEBPACK FOOTER //
// ./src/store/global/initialState.js